/*前端页面使用的常量*/
const ARTICLE_TYPE_LIST = [
    { name: '请选择', id: ''},
    { name: "图文", id: 0 },
    { name: "视频", id: 1 },
    { name: "小说", id: 50 },
    { name: "漫画", id: 60 }
];
const ARTICLE_STATUS_LIST = [
    {name: '全部', id: ''},
    {name: '草稿中', id: 0},
    {name: '待审核', id: 10},
    {name: '外团已通过', id: 15},
    {name: '供应商已通过', id: 18},
    {name: '已通过', id: 20},
    {name: '已发布', id: 30},
    {name: '已驳回', id: 50},
    {name: '已定时', id: 40},
    {name: '已下线', id: 60},
    {name: '已删除', id: 70}
];
function objToStrMap(obj) {
    let strMap = new Map();
    for (let v of Object.values(obj)) {
        strMap.set(v.id, v.name);
    }
    return strMap;
}

let MAP_ARTICLE_STATUS_LIST = objToStrMap(ARTICLE_STATUS_LIST);
let MAP_ARTICLE_TYPE_LIST =    objToStrMap(ARTICLE_TYPE_LIST);

export  {
    ARTICLE_TYPE_LIST,
    MAP_ARTICLE_STATUS_LIST,
    MAP_ARTICLE_TYPE_LIST
};
